import React from "react"
import { useDrag } from "react-dnd"
import { Paper, Stack, Typography, Chip } from "@mui/material"
import BuildIcon from "@mui/icons-material/Build"
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing"
import { ItemTypes } from "../VisualEditorContext"

const DraggableMaterial = ({ material }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: ItemTypes.MATERIAL,
    item: { type: ItemTypes.MATERIAL, material },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }), [material])

  const isMaterial = material.usageType === "MATERIAL"
  const isPurchased = material.usageType === "PURCHASED-MATERIAL"

  return (
    <Paper
      ref={drag}
      elevation={0}
      sx={{
        p: 1.5,
        cursor: "grab",
        opacity: isDragging ? 0.5 : 1,
        border: "1px solid #e2e8f0",
        borderRadius: 2,
        transition: "all 0.2s ease",
        "&:hover": {
          borderColor: isMaterial ? "#3b82f6" : "#d97706",
          bgcolor: "#f8fafc",
          transform: "translateY(-2px)",
          boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)",
        },
        "&:active": {
          cursor: "grabbing",
        },
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        {isMaterial ? (
          <BuildIcon sx={{ fontSize: 18, color: "#3b82f6" }} />
        ) : (
          <PrecisionManufacturingIcon sx={{ fontSize: 18, color: "#d97706" }} />
        )}
        <Stack sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="body2"
            fontWeight={500}
            color="#1e293b"
            noWrap
            sx={{ maxWidth: 180 }}
          >
            {material.name}
          </Typography>
          <Stack direction="row" spacing={0.5} alignItems="center">
            <Chip
              size="small"
              label={isMaterial ? "Material" : "Purchased"}
              sx={{
                height: 18,
                fontSize: "0.65rem",
                bgcolor: isMaterial ? "#dbeafe" : "#fef3c7",
                color: isMaterial ? "#1d4ed8" : "#d97706",
              }}
            />
            <Typography variant="caption" color="#64748b">
              {material.unit}
            </Typography>
          </Stack>
        </Stack>
        {material.costprice > 0 && (
          <Typography variant="caption" fontWeight={600} color="#16a34a">
            €{parseFloat(material.costprice).toFixed(2)}
          </Typography>
        )}
      </Stack>
    </Paper>
  )
}

export default DraggableMaterial
